import { useDispatch, useSelector } from "react-redux";
import AddUserBycostCenter from "./AddUserByCostCenter";
import { useCallback, useEffect, useRef, useState } from "react";
import { setCostCenterBySearchString } from "Store/Organization/CostCenters/CostCentersAction";
import { getSaveUserByCostCenter, getUsersByCostCenter, setSaveUserByCostCenter, setUsersByCostCenter } from "Store/AssetInventory/Users/UsersAction";
import { Checkbox } from "client/CommonComponents";
import { addEmployeeToCostCenter, getEmployeesWithHomeCostCenterList, getUserFilterBySearchText, setEmployeesWithHomeCostCenterList, setIsEmployeeAddedToCostCenter, setUserFilterBySearchText } from "Store/Identity/UserBySearchText/UserBySearchTextAction";
import { useNavigate } from "react-router-dom";
import { popupInitialData } from "utils";
import confirmationBee from '../../../../assets/images/ConfirmationBee.svg';
import userProfileSelectors from '../../../../../redux/UserProfile/selectors';
import successBee from '../../../../assets/images/SuccessBee.svg';
import permissions, { isAuthorized } from "client/utils/Permissions";
import { getCostCenterByIdAndRole, setCostCenterByIdAndRole } from "Store/AssetInventory/BranchAdminAccess/BranchAdminAccessAction";

const AddUserBycostCenterContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const changedTableTemp: any = useRef(null);
    const initialTableData: any = useRef([]);
    const changedArr: any = useRef([]);
    const [costCentersBySearchList, setCostCentersBySearchList] = useState([])
    const [usersBySearchList, setUsersBySearchList] = useState([])
    const [selectedSearchedCostCenter, setSelectedSearchedCostCenter] = useState<any>()
    const [selectedSearchedEmployee, setSelectedSearchedEmployee] = useState<any>()
    const [PopupContent, setPopupContent] = useState<any>(popupInitialData)
    const [addUserError, setAddUserError] = useState<any>('')

    const [paginationData, setPaginationData] = useState<any>({})
    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const [sortData, setSortData] = useState<any>('')
    const [showGrid, setShowGrid] = useState<boolean>(false)

    const [employeesList, setEmployeesList] = useState<any>([])
    const [selectedEmployee, setSelectedEmployee] = useState<any>('')

    ///selectors
    const {
        usersByCostCenter,
        usersBySearchText,
        loginUserDetails,
        isSaveUserByCostCenter,
        isEmployeeAddedToCostCenter,
        employeesWithHomeCostCenterList,
        costCenterByIdAndRole
    }: any = useSelector((state: any) => ({
        usersByCostCenter: state.UsersReducer.usersByCostCenter,
        usersBySearchText: state.UserFilterBySearchTextReducers.usersBySearchText,
        loginUserDetails: userProfileSelectors.getUserDetails(state),
        isSaveUserByCostCenter: state.UsersReducer.isSaveUserByCostCenter,
        isEmployeeAddedToCostCenter: state.UserFilterBySearchTextReducers.isEmployeeAddedToCostCenter,
        employeesWithHomeCostCenterList: state.UserFilterBySearchTextReducers.employeesWithHomeCostCenterList,
        costCenterByIdAndRole: state.BranchAdminAccessReducer.costCenterByIdAndRole
    }))

    const clearValues = () => {
        setSelectedSearchedEmployee(null)
        setSelectedSearchedCostCenter(null)
        dispatch(setUsersByCostCenter(null))
        changedTableTemp.current = []
        initialTableData.current = []
        setTableData([])
        setShowGrid(false)
        setCostCentersBySearchList([])
        dispatch(setUserFilterBySearchText(null))
        dispatch(setCostCenterBySearchString(null))
        setUsersBySearchList([])
        dispatch(setSaveUserByCostCenter(null))
        setAddUserError('')
    }

    useEffect(() => {
        if (loginUserDetails?.permissions && !(isAuthorized(permissions.Assign_Users) || isAuthorized(permissions.View_Users))) {
            navigate('/assetinventory')
        }
    }, [loginUserDetails])

    useEffect(() => {
        if (!(isAuthorized(permissions.Assign_Users) || isAuthorized(permissions.View_Users)) && loginUserDetails?.permissions) {
            navigate('/assetinventory')
        }
        hideDialogComplete()
        clearValues()

        return () => {
            dispatch(setIsEmployeeAddedToCostCenter(undefined))
            dispatch(setEmployeesWithHomeCostCenterList([]))
            dispatch(setCostCenterByIdAndRole([]));
        }
    }, [])

    useEffect(() => {
        if (isSaveUserByCostCenter && isSaveUserByCostCenter != null) {
            let decriptionTxt = (<p>Changes saved successfully</p>);
            commonPopupDialog("SUCCESS", decriptionTxt, "Ok", true, null, successBee, "successPopup")
        } else if (!isSaveUserByCostCenter && isSaveUserByCostCenter != null) {
            let decriptionTxt = (<p>Error occured while saving the changes!!</p>);
            commonPopupDialog("ERROR", decriptionTxt, "Ok", true, null, confirmationBee, "errorPopup")
        }
    }, [isSaveUserByCostCenter])

    useEffect(() => {
        if (costCenterByIdAndRole?.length) {
            const costcenterDropdownListTemp = costCenterByIdAndRole?.map((item: any) => ({ ...item, label: item?.text }));
            setCostCentersBySearchList(costcenterDropdownListTemp);
        }
    }, [costCenterByIdAndRole])

    useEffect(() => {
        if (usersBySearchText?.length) {
            const usersBySearchDropDownListTemp = usersBySearchText?.map((item: any) => ({ ...item, label: item?.text, value: item?.value }));
            setUsersBySearchList(usersBySearchDropDownListTemp);
        }
        
    }, [usersBySearchText])

    useEffect(() => {
        if (employeesWithHomeCostCenterList?.length) {
            const usersDropDownListTemp = employeesWithHomeCostCenterList?.map((item: any) => ({ ...item, label: item?.text, value: item?.value }));
            setEmployeesList(usersDropDownListTemp)
        }
    }, [employeesWithHomeCostCenterList])

    useEffect(() => {
        if (usersByCostCenter?.data?.length > 0 && selectedSearchedCostCenter) {
            initialTableData.current = usersByCostCenter?.data
            let usersByCostCenterTemp = JSON.parse(JSON.stringify(usersByCostCenter?.data))
            usersByCostCenterTemp?.map((initialVal?: any) => {
                changedArr.current?.map((changedVal?: any) => {
                    if (initialVal?.userId == changedVal?.userId) {
                        initialVal.employeeId = changedVal?.employeeId
                        initialVal.isAssetInventory = changedVal?.isAssetInventory
                        initialVal.isAssetTraining = changedVal?.isAssetTraining
                        initialVal.isMAScanning = changedVal?.isMAScanning
                        initialVal.isAssetMaintenance = changedVal?.isAssetMaintenance
                        initialVal.name = changedVal?.name
                        initialVal.title = changedVal?.title
                        initialVal.userId = changedVal?.userId
                    }
                })
            })
            changedTableTemp.current = usersByCostCenterTemp
            setShowGrid(true)
            setServerTotal(usersByCostCenter?.totalRecords)
        }
        else if (usersByCostCenter?.data?.length == 0 && selectedSearchedCostCenter) {
            changedTableTemp.current = []
            setTableData([])
            setShowGrid(true)
            setServerTotal(0)
        }
    }, [usersByCostCenter])

    useEffect(() => {
        if (isEmployeeAddedToCostCenter === 'added') {
            let decriptionTxt = (<p>User added successfully</p>);
            commonPopupDialog("SUCCESS", decriptionTxt, "Ok", true, null, successBee, "")
            setSelectedEmployee('')
            setAddUserError('')
            fetchGridData(selectedSearchedCostCenter, selectedSearchedEmployee)
        } else if (isEmployeeAddedToCostCenter === 'exists') {
            setAddUserError('User already added to cost center')
        } else if (isEmployeeAddedToCostCenter === 'error') {
            let decriptionTxt = (<p>Error occured while adding the user!!</p>);
            commonPopupDialog("ERROR", decriptionTxt, "Ok", true, null, confirmationBee, "")
        }
        dispatch(setIsEmployeeAddedToCostCenter(undefined))
    }, [isEmployeeAddedToCostCenter])

    const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
            setPaginationData(fetchData.data)
            fetchGridData(selectedSearchedCostCenter, selectedSearchedEmployee, fetchData.data, sortData)
        }
        if (fetchData.action && fetchData.action === "sorting") {
            setSortData(fetchData.data[0]);
            fetchGridData(selectedSearchedCostCenter, selectedSearchedEmployee, paginationData, fetchData.data[0])
        }
    }, [selectedSearchedCostCenter, selectedSearchedEmployee])

    const getPaginationData = (userValue?: any, pageData?: any) => {
        if (pageData?.pageIndex != undefined && userValue?.value) {
            return 1
        } else if (pageData?.pageIndex != undefined) {
            return pageData?.pageIndex + 1
        } else {
            return 1
        }
    }

    const fetchGridData = (costCenter?: any, userValue?: any, pageData?: any, sortingData?: any) => {
        if (costCenter?.value) {
            let payload: any = {
                pageNumber: getPaginationData(userValue, pageData),
                pageSize: pageData?.pageSize,
                globalSearch: userValue?.value,
                costCenterId: parseInt(costCenter?.value)
            }
            if (sortingData?.key != '') {
                payload.sortBy = sortingData?.key;
                payload.sortOrder = sortingData?.sortDirection;
            }
            dispatch(getUsersByCostCenter(payload))
        }
    }

    const handleChangeSearchedCostCenter = (value: any, name: string) => {
        setSelectedSearchedCostCenter(value)
        setAddUserError('')
        fetchGridData(value, selectedSearchedEmployee)
        changedArr.current = []
    }

    const searchCostCenter = (value: any, action: any) => {
        if (action.action === "input-change") {
            dispatch(getCostCenterByIdAndRole({
                userId: loginUserDetails?.userId,
                searchValue: value
            }))
        }
    };

    const handleChangeSearchedEmployee = (value: any) => {
        setSelectedSearchedEmployee(value)
        fetchGridData(selectedSearchedCostCenter, value)
        setShowGrid(false)
    }

    const searchEmployee = (value: any, action: any) => {
        if (action.action === "input-change") {
            dispatch(getUserFilterBySearchText(value))
        }
    };

    const [tableData, setTableData] = useState<any>([])

    useEffect(() => {
        setTableData(changedTableTemp.current)
    }, [changedTableTemp.current])

    const onIsCheckBoxChange = (rowData?: any, columnName?: any) => {
        let valArr: any = {}
        let assetInventoryUserTableTemp = changedTableTemp.current ? JSON.parse(JSON.stringify(changedTableTemp.current)) : [];
        assetInventoryUserTableTemp?.forEach((valTemp: any) => {
            if (valTemp?.userId === rowData?.userId) {
                if (columnName === 'Asset Training') {
                    valTemp.isAssetTraining = !valTemp?.isAssetTraining;
                    valArr = { ...valTemp };
                } else if (columnName === 'Asset Inventory') {
                    valTemp.isAssetInventory = !valTemp?.isAssetInventory;
                    valArr = { ...valTemp };
                } else if (columnName === "M&A Scanning") {
                    valTemp.isMAScanning = !valTemp?.isMAScanning;
                    valArr = { ...valTemp };
                } else if (columnName === "Asset Maintenance") {
                    valTemp.isAssetMaintenance = !valTemp?.isAssetMaintenance;
                    valArr = { ...valTemp };
                }
            }
        });
        if (valArr?.hasOwnProperty('userId')) {
            changedArr.current?.map((item?: any, index?: any) => {
                if (item?.userId == rowData?.userId) {
                    changedArr.current.splice(index, 1)
                }
            })
            changedArr.current.push(valArr)

            ///If we are changing it to initial state then remove the object from array
            if (changedArr.current?.length > 0) {
                changedArr.current?.map((item?: any, itemIndex?: any) => {
                    initialTableData?.current?.map((val?: any, index?: any) => {
                        if (item?.userId == val?.userId
                            && item?.employeeId == val?.employeeId
                            && item?.isAssetInventory == val?.isAssetInventory
                            && item?.isAssetTraining == val?.isAssetTraining
                            && item?.isMAScanning == val?.isMAScanning
                            && item?.isAssetMaintenance == val?.isAssetMaintenance
                            && item?.name == val?.name
                            && item?.title == val?.title
                            && item?.userId == val?.userId
                        ) {
                            changedArr.current.splice(itemIndex, 1)
                        }
                    })
                })
            }
            let changedArrTemp = changedArr.current;
            changedArr.current = changedArrTemp;
            changedTableTemp.current = assetInventoryUserTableTemp
            setTableData(assetInventoryUserTableTemp)
        }
    }

    const columns = [
        {
            key: "name",
            title: "Name",
        },
        {
            key: "title",
            title: "Title",
        },
        {
            key: "employeeId",
            title: "Employee ID",
        },
        {
            key: "isAssetTraining",
            title: "Asset Training",
            Cell: (row: any) => {
                return (
                    <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.title)} checked={row?.rowData?.isAssetTraining}  data-attribute="AddUserByCostCenter_Container_Default_Checkbox" />
                );
            },
        },
        {
            key: "isAssetInventory",
            title: "Asset Inventory",
            Cell: (row: any) => {
                return (
                    <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.title)} checked={row?.rowData?.isAssetInventory}  data-attribute="AddUserByCostCenter_Container_Default_Checkbox_2" />
                );
            },
        },
        {
            key: "isMAScanning",
            title: "M&A Scanning",
            Cell: (row: any) => {
                return (
                    <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.title)} checked={row?.rowData?.isMAScanning}  data-attribute="AddUserByCostCenter_Container_Default_Checkbox_3" />
                );
            },
        },
        {
            key: "isAssetMaintenance",
            title: "Asset Maintenance",
            Cell: (row: any) => {
                return (
                    <Checkbox className="mb-0 checkboxName" onChange={() => onIsCheckBoxChange(row?.rowData, row?.column?.title)} checked={row?.rowData?.isAssetMaintenance}  data-attribute="AddUserByCostCenter_Container_Default_Checkbox_4" />
                );
            },
        },
    ];

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
            let pageSize = paginationData?.pageSize
            let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
            setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])

    const handleClickReset = (e?: any) => {
        e.preventDefault();
        clearValues()
        setSelectedEmployee('')
    }

    const commonPopupDialog = (title: string, description: any, outlineBtnText: string, isSingleConfirmationBtn: any, popupPrimaryBtnText: any, titleImage?: any, type?: any) => {
        setPopupContent({
            ...PopupContent,
            title: title,
            titleImg: titleImage,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: description,
            outlineBtnText: outlineBtnText,
            isSingleConfirmationBtn: isSingleConfirmationBtn,
            popupOutlinebtnOnclick: () => {
                hideDialogComplete()
                dispatch(setSaveUserByCostCenter(null))
                if (type == "successPopup" || type == "errorPopup") {
                    changedArr.current = []
                    dispatch(setUsersByCostCenter(null))
                    changedTableTemp.current = []
                    initialTableData.current = []
                    setTableData([])
                    fetchGridData(selectedSearchedCostCenter, selectedSearchedEmployee)
                }
            },
            primaryBtnText: popupPrimaryBtnText,
            popupPrimarybtnOnclick: () => {
                hideDialogComplete()
                if (type == "Cancel") {
                    clearValues()
                    navigate('/assetinventory')
                } else if (type == "Save") {
                    if (changedArr.current.length > 0) {
                        let payload: any = {}
                        let inventoryUsersTemp: any = []
                        changedArr.current?.map((item?: any) => {
                            inventoryUsersTemp.push({
                                "userId": parseInt(item?.userId),
                                "isAssetTraining": item?.isAssetTraining,
                                "isAssetInventory": item?.isAssetInventory,
                                "isMAScanning": item?.isMAScanning,
                                "isAssetMaintenance": item?.isAssetMaintenance
                            })
                        })
                        payload = {
                            "costCenterId": parseInt(selectedSearchedCostCenter?.value),
                            "savedBy": loginUserDetails?.emailId,
                            "inventoryUsers": inventoryUsersTemp
                        }
                        dispatch(getSaveUserByCostCenter(payload))
                    }
                }
            }
        });
    }

    const handleSaveClick = () => {
        let decriptionTxt = (<p>Are you sure you want to save the changes?</p>);
        commonPopupDialog("CONFIRMATION", decriptionTxt, "No", false, "Yes", confirmationBee, "Save")
    }

    const handleCancelClick = () => {
        let decriptionTxt = (<p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>);
        commonPopupDialog("CONFIRMATION", decriptionTxt, "No", false, "Yes", confirmationBee, "Cancel")
    }

    const hideDialogComplete = () => {
        setPopupContent({ ...PopupContent, isDialogVisible: false })
    };

    const breadcrumlist = [
        { text: 'Users', key: 'f1', href: '/assetinventory', onClick: (e: any) => { e.preventDefault(); clearValues(); navigate('/assetinventory'); } },
        { text: 'Add Users by cost Center', key: 'f2' }
    ]

    const handleClickBack = () => {
        clearValues()
        navigate('/assetinventory')
    }

    const handleChangeSearchEmployee = (value: any) => {
        setSelectedEmployee(value)
        setAddUserError('')
    }

    const onCancelEmployeeClick = () => {
        setSelectedEmployee('')
        setAddUserError('')
    }

    const onAddEmployeeClick = () => {
        const payload = {
            costCenterId: parseInt(selectedSearchedCostCenter?.value),
            savedBy: loginUserDetails?.emailId,
            userId: parseInt(selectedEmployee?.value)
        }

        dispatch(addEmployeeToCostCenter(payload))
    }

    const fetchEmployeelist = (value: any, action: any) => {
        if (action.action === "input-change") {
            dispatch(getEmployeesWithHomeCostCenterList(value))
        }
    };

    return (
        <AddUserBycostCenter
            handleChangeSearchedCostCenter={handleChangeSearchedCostCenter}
            searchCostCenter={searchCostCenter}
            costCentersBySearchList={costCentersBySearchList}
            selectedSearchedCostCenter={selectedSearchedCostCenter}
            columns={columns}
            fetchAction={fetchAction}
            serverTotal={serverTotal}
            pagesCount={pagesCount}
            changedTableTemp={changedTableTemp}
            showGrid={showGrid}
            handleClickReset={handleClickReset}
            handleChangeSearchedEmployee={handleChangeSearchedEmployee}
            searchEmployee={searchEmployee}
            selectedSearchedEmployee={selectedSearchedEmployee}
            usersBySearchList={usersBySearchList}
            changedArr={changedArr}
            handleSaveClick={handleSaveClick}
            handleCancelClick={handleCancelClick}
            tableData={tableData}
            hideDialogComplete={hideDialogComplete}
            PopupContent={PopupContent}
            breadcrumlist={breadcrumlist}
            handleClickBack={handleClickBack}
            employeesList={employeesList}
            selectedEmployee={selectedEmployee}
            handleChangeSearchEmployee={handleChangeSearchEmployee}
            onCancelEmployeeClick={onCancelEmployeeClick}
            onAddEmployeeClick={onAddEmployeeClick}
            fetchEmployeelist={fetchEmployeelist}
            addUserError = {addUserError}
        />
    )

}
export default AddUserBycostCenterContainer;